export default {
  endCallForAll: 'END_CALL_FOR_ALL_MODAL',
  endRemoteModeration: 'END_REMOTE_MODERATION_MODAL',
  removeFromMeeting: 'REMOVE_FROM_MEETING_MODAL',
  stopPresenter: 'STOP_PRESENTER_MODAL',
  stopPresentation: 'STOP_PRESENTATION_MODAL',
  waitingRoomWarningModal: 'WAITING_ROOM_WARNING_MODAL'
};
